import { createSelector } from "reselect";
import { selectActiveFilterConfiguration, selectFacetsWithResultsMap } from "~/features/search/redux/searchSelectors";
import {
  type FacetFilterData,
  Filter,
  type TechFilter,
  type TechValueFilterCategoryData,
} from "~/features/search/models/filterConfigModels";

export const selectVisibleFilters = createSelector(
  selectActiveFilterConfiguration,
  selectFacetsWithResultsMap,
  (filterConfig, visibilityMap) => {
    if (!filterConfig || !visibilityMap) {
      return [];
    }
    const isTechFilterVisible = (techFilter: TechFilter) => {
      return techFilter.visibleOnFilters && visibilityMap[techFilter.uid];
    };
    const isTechCategoryVisible = (techValueCategory: TechValueFilterCategoryData) => {
      return techValueCategory.items.length > 0;
    };

    const isFacetFilterVisible = (facetFilter: FacetFilterData) => {
      return visibilityMap[facetFilter.code];
    };

    const visibleFilterConfig = filterConfig
      .map((item) => {
        if (item.type === Filter.TECH_VALUE) {
          return {
            ...item,
            items: item.items.filter(isTechFilterVisible),
          };
        }
        return item;
      })
      .filter((item) => {
        if (item.type === Filter.TECH_VALUE) {
          return isTechCategoryVisible(item);
        }
        if (item.type === Filter.FACET) {
          return isFacetFilterVisible(item);
        }
        return true;
      });

    return visibleFilterConfig;
  },
);

export const selectL1Categories = createSelector(selectActiveFilterConfiguration, (filterConfig) => {
  if (!filterConfig) {
    return null;
  }
  const taxonomyData = filterConfig.find((item) => item.type === Filter.TAXONOMY);
  return taxonomyData?.categories;
});
